var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{ref:"img",staticClass:"parallax-image",style:({transform: ("translate(" + ((_vm.horizontal - 0.5) * _vm.shift) + "px, " + ((_vm.vertical - 0.5) * 0.47 * _vm.shift) + "px)")}),attrs:{"src":_vm.src},on:{"load":_vm.loadedImg}})}
var staticRenderFns = []

export { render, staticRenderFns }